// import parseISO from 'date-fns/parseISO';
import { GET_BONUSES, UI_START_LOADING, UI_STOP_LOADING } from '../actions/types';

const initialState = {
  list: [],
  isLoading: false
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_BONUSES: {
      return { ...state, ...{ list: action.data } };
    }
    case UI_START_LOADING: {
      return { ...state, isLoading: true };
    }
    case UI_STOP_LOADING: {
      return { ...state, isLoading: false };
    }
    default:
      return state;
  }
}
